/* eslint-disable @typescript-eslint/no-explicit-any */
export const checkEnumValue = <Enum extends { [name: string]: any }, F = Enum[keyof Enum]>(
  value: Enum[keyof Enum] | any,
  enumeration: Enum,
  fallback: F,
): Enum[keyof Enum] | F => (Object.values(enumeration).includes(value as Enum) ? value : fallback)
